/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const GuideDetailPage = lazyLoad(
  () => import('./index'),
  module => module.GuideDetailPage
);
